/**
 * Create technical name to store internally.
 * E.g. [AskTeacher]John Doe
 * @param studentDisplayName
 */
export const createAskTeacherThreadName = (studentDisplayName: string) => `[AskTeacher]${studentDisplayName}`;

/**
 * Transform chat thread topic for display in student app.
 *
 * @param topic
 */
export const transformTopicForStudent = (topic?: string) => {
    if (isAskTeacherThreadTopic(topic)) {
        return "Frage stellen";
    }

    return topic ?? "default thread";
};

/**
 * Transform chat thread topic for display in moderator app.
 *
 * @param topic
 */
export const transformTopicForModerator = (topic?: string): string => {
    if (isAskTeacherThreadTopic(topic)) {
        return topic.replace("[AskTeacher]", "Privater Chat mit ");
    }

    return topic ?? "default thread";
};

export const isAskTeacherThreadTopic = (topic?: string): topic is string => topic !== undefined && topic.startsWith("[AskTeacher]");

export const isGroupChatThreadTopic = (topic?: string): boolean => topic === "Gruppenchat";
